package com.example.mystybag.appCore.views.components

import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.aspectRatio
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.HorizontalDivider
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.example.mystybag.common.resources.SR
import com.example.mystybag.common.ui.components.custom.ImageDescriptionView
import com.example.mystybag.common.ui.components.native.Texts
import com.example.mystybag.core.model.ImageDescription
import com.example.mystybag.core.views.AppTheme
import dev.icerock.moko.resources.compose.stringResource

private val MenuThumbCornerRadius = 20.dp
private val MenuThumbGap = 9.dp
private val MenuThumbColumns = 4
private val MenuSectionLabelToDivider = 12.dp
private val MenuDividerToThumbnails = 16.dp

/** Figma Details (node 51451:6238): section label + outline divider, thumbnails 121∶140, 9dp gap, 20dp radius, outline border. */
@Composable
fun MenuPhotosSection(
    menuPhotoUrls: List<String>,
    onMenuPhotoClick: (String) -> Unit,
    modifier: Modifier = Modifier
) {
    val urls = menuPhotoUrls.map { it.trim() }.filter { it.isNotEmpty() }
    if (urls.isEmpty()) return

    val thumbShape = RoundedCornerShape(MenuThumbCornerRadius)
    val outline = AppTheme.current.colors.outline

    Column(modifier = modifier.fillMaxWidth()) {
        Texts.Label(
            text = stringResource(SR.strings.menu_section_header),
            modifier = Modifier.fillMaxWidth(),
            color = AppTheme.current.colors.onSurfaceVariant,
            textStyle = AppTheme.current.typography.labelMedium.copy(
                fontWeight = FontWeight.Normal,
                letterSpacing = 0.48.sp,
                lineHeight = 16.sp
            )
        )
        Spacer(modifier = Modifier.height(MenuSectionLabelToDivider))
        HorizontalDivider(thickness = 1.dp, color = outline)
        Spacer(modifier = Modifier.height(MenuDividerToThumbnails))
        BoxWithConstraints(modifier = Modifier.fillMaxWidth()) {
            val thumbWidth =
                (maxWidth - MenuThumbGap * (MenuThumbColumns - 1)) / MenuThumbColumns
            val scrollState = rememberScrollState()
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .horizontalScroll(scrollState),
                horizontalArrangement = Arrangement.spacedBy(MenuThumbGap)
            ) {
                urls.forEach { url ->
                    Box(
                        modifier = Modifier
                            .width(thumbWidth)
                            .aspectRatio(121f / 140f)
                            .clip(thumbShape)
                            .border(1.dp, outline, thumbShape)
                            .clickable { onMenuPhotoClick(url) }
                    ) {
                        ImageDescriptionView(
                            modifier = Modifier.fillMaxSize(),
                            image = ImageDescription(link = url, icon = null),
                            contentScale = ContentScale.Crop,
                            shimmerShape = thumbShape
                        )
                    }
                }
            }
        }
    }
}
